import React, { useState, useMemo } from "react";
import {
  Box, Grid, Typography, Button, TextField, InputAdornment,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Chip, IconButton, Pagination, Avatar
} from "@mui/material";
import {
  Search as SearchIcon, EditOutlined, DeleteOutline, Add
} from "@mui/icons-material";
import useStyles from "./style";
import { useDispatch, useSelector } from "react-redux";
import {Plus} from "lucide-react";
import "@fontsource/poppins";



//Modals
import ServicetypeAddModal from "Pages/Modals/CityServicetypefare/Create";
import ServicetypeUpdateModal from "Pages/Modals/CityServicetypefare/Update";
import ServicetypeDeleteDialog from "Pages/Modals/CityServicetypefare/Delete";




// Dummy Data for City Fare
const dummyData = [
  {
    id: "01",
    serviceImage: "https://cdn-icons-png.flaticon.com/512/2552/2552808.png", // Sedan
    serviceType: "Sedan",
    city: "Chennai",
    status: "Active"
  },
  {
    id: "02",
    serviceImage: "https://cdn-icons-png.flaticon.com/512/3094/3094831.png", // Van
    serviceType: "Small Van",
    city: "Coimbatore",
    status: "Active"
  },
  {
    id: "03",
    serviceImage: "https://cdn-icons-png.flaticon.com/512/3094/3094888.png", // Auto
    serviceType: "Tuk Tuk",
    city: "Chennai",
    status: "Active"
  },
  {
    id: "04",
    serviceImage: "https://cdn-icons-png.flaticon.com/512/2552/2552808.png",
    serviceType: "Luxury SUV",
    city: "Bangalore",
    status: "Inactive"
  },
  {
    id: "05",
    serviceImage: "https://cdn-icons-png.flaticon.com/512/3094/3094831.png",
    serviceType: "Mini",
    city: "Madurai",
    status: "Active"
  },
];


const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "#ffffff",
    padding: "24px",
    boxSizing: "border-box",
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    width: "100%",
    background: "#FFFFFF",
    border: "none",
    borderRadius: "16px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
  },
  header: {
    display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between",
    gap: "12px", padding: "20px 24px", borderBottom: "none", fontSize: "20px", fontFamily: "Poppins",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "16px" },
  title: { margin: 0, fontSize: "18px", fontWeight: 600, color: "#111827", marginLeft: "-20px", fontFamily: "Poppins" },
  addBtn: {
    display: "flex", alignItems: "center", gap: "6px", background: "#090d15",  color: "#fff",
    border: "none", borderRadius: "8px", padding: "14px 16px", fontSize: "14px", fontWeight: 500, cursor: "pointer",
  },
  breadcrumb: { fontSize: "20px", color: "#6B7280", paddingRight:"40px" },
  breadcrumbActive: { fontWeight: 500, color: "#111827" },
  toolbar: {
    display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between",
    gap: "16px", padding: "16px 24px",
  },
  searchWrap: { position: "relative", width: "100%", maxWidth: "320px" },
  searchIcon: { position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: "#9CA3AF" },
  searchInput: {
    width: "100%", boxSizing: "border-box", padding: "10px 16px 10px 40px", border: "1px solid #E5E7EB",
    borderRadius: "999px", fontSize: "14px", color: "#374151", background: "#F9FAFB", outline: "none",
  },
  exportGroup: { display: "flex", background: "#111827", borderRadius: "8px", overflow: "hidden" },
  exportBtn: {
    border: "none", background: "transparent", color: "#D1D5DB", fontSize: "14px", fontWeight: 500,
    padding: "8px 16px", cursor: "pointer", transition: "0.2s",
  },
  exportBtnHover: { background: "#1F2937", color: "#fff" },
  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", textAlign: "left" },
  theadRow: { background: "#F9FAFB" },
  th: {
    padding: "14px 24px", fontSize: "16px", fontWeight: 600, textTransform: "uppercase",
    letterSpacing: "0.05em", color: "#2d3238", borderBottom: "1px solid #E5E7EB",
  },
  td: { padding: "16px 24px", fontSize: "15px", color: "#374151", borderBottom: "1px solid #F3F4F6" },
  rowHover: { background: "#F9FAFB" },
  emptyCell: { textAlign: "center", padding: "40px 24px", color: "#9CA3AF" },
  actionGroup: { display: "flex", gap: "12px" },
  editBtn: {
    display: "inline-flex", alignItems: "center", gap: "6px", border: "none", background: "none",
    padding: 0, fontSize: "14px", color: "#6B7280", cursor: "pointer", fontWeight: 500,
  },
  deleteBtn: {
    display: "inline-flex", alignItems: "center", gap: "6px", border: "none", background: "none",
    padding: 0, fontSize: "14px", color: "#EF4444", cursor: "pointer", fontWeight: 500,
  },
  footer: {
    display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between",
    gap: "12px", padding: "16px 24px", borderTop: "1px solid #F1F5F9",
  },
  resultsText: { margin: 0, fontSize: "14px", color: "#6B7280" },
  pagination: { display: "flex", alignItems: "center", gap: "6px" },
  pageNavBtn: {
    display: "flex", alignItems: "center", justifyContent: "center", height: "36px", width: "36px",
    borderRadius: "8px", fontSize: "14px", fontWeight: 500, cursor: "pointer", border: "1px solid #E5E7EB",
    background: "#FFFFFF", color: "#6B7280",
  },
  pageNavBtnDisabled: { opacity: 0.4, cursor: "not-allowed" },
  pageBtn: {
    display: "flex", alignItems: "center", justifyContent: "center", height: "36px", minWidth: "36px",
    borderRadius: "8px", fontSize: "14px", fontWeight: 500, cursor: "pointer", border: "1px solid transparent",
    background: "none", color: "#6B7280",
  },
  pageBtnActive: { background: "#111827", color: "#FFFFFF", border: "1px solid #111827" },
  pageDots: { padding: "0 8px", fontSize: "14px", color: "#9CA3AF" },
};

const CityServicetypefare = ({ onAddClick }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  
  const [addServicetypeModal, setaddServicetypeModal] = useState(false);
  const [updateServicetypeModal, setupdateServicetypeModal] = useState(false);
  const [data] = useState(dummyData);
  const rowsPerPage = 5;
  const totalResults = 124; // for dummy pagination count

  const filteredData = useMemo(() => {
    return data.filter(item =>
      item.id.toLowerCase().includes(search.toLowerCase()) ||
      item.serviceType.toLowerCase().includes(search.toLowerCase()) ||
      item.city.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, data]);

  const paginatedData = filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  const handleExport = (type) => {
    console.log(`${type} clicked`);
  };

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

   const handleCloseUpdateServiceModal = () => {
    setupdateServicetypeModal(false);
    
  };
  const [deleteServicetypeModal, setdeleteServicetypeModal] = useState(false);
  const handleCloseDeleteServiceModal = (row) => {
    setdeleteServicetypeModal(false);
    
  };

    const handleCloseAddServiceModal = () => {
    setaddServicetypeModal(false);
   
  };

  const classes = useStyles();

   const handleOpenAddServiceModal = () => {
    setaddServicetypeModal(true);
  };

  return (
    <>
    <Box sx={{ p: 3, fontFamily: "Poppins" }}>
      <Paper sx={{ p: 3, borderRadius: 4, boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",  }}>

        {/* Header */}
        {/* <Grid container justifyContent="space-between" alignItems="center" mb={2}>
          <Grid item xs={12} md={6} sx={{ display: "flex", alignItems: "center", gap: 2, mb: { xs: 2, md: 0 } }}>
            <Typography variant="h6" fontWeight={900} fontSize={"17px"}>City wise Fare Management</Typography>
            <Grid item xs={8} md={8} lg={8} xl={8} className={classes.funBtn}>
                    {!demoaccount_id &&  <Button variant="contained" onClick={handleOpenAddServiceModal}>
                      + Add Fare Model
                     </Button> }
                   </Grid>
          </Grid>
          <Grid item>
            <Typography color="text.secondary">
              Admin / <Typography component="span" color="#000" fontWeight={600}>List Fare model</Typography>
            </Typography>
          </Grid>
        </Grid> */}

         <div style={styles.header}>
                  <div style={styles.headerLeft}>
                    <h1 style={styles.title}>City wise Fare Management</h1>
                    <button style={styles.addBtn} onClick={handleOpenAddServiceModal}>
                      <Plus size={16} /> Add Fare Model
                    </button>
                  </div>
                  <div style={styles.breadcrumb}>
                    <span>Admin</span> / <span style={styles.breadcrumbActive}>List Fare model</span>
                  </div>
                </div>

        {/* Search + Export */}
        <Grid container justifyContent="space-between" alignItems="center" mb={3} spacing={2}>
          <Grid item xs={12} md={5}>
            <TextField

  size="small"
  placeholder="Search"
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setPage(1);
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: "100px", // Increase border radius
      width: "300px",
      backgroundColor: "#fff",
    },
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon sx={{ color: "#888" }} />
      </InputAdornment>
    ),
  }}
/>
          </Grid>
          <Grid item>
            {/* <Box sx={{ display: "flex", bgcolor: "#000", borderRadius: 1, padding:"15px", overflow: "hidden" }}>
              {["Copy", "Excel", "CSV", "PDF"].map(btn => (
                <Button
                  key={btn}
                  size="small"
                  onClick={() => handleExport(btn)}
                  sx={{ color: "#fff", textTransform: "none", px: 2, minWidth: 70, borderRight: "1px solid #fff", "&:hover": { bgcolor: "#222" } }}
                >
                  {btn}
                </Button>
              ))}
            </Box> */}

            <Box
  sx={{
    display: "flex",
    bgcolor: "#000",
    borderRadius: "6px",
    overflow: "hidden",
  }}
>
  {["Copy", "Excel", "CSV", "PDF"].map((item, index) => (
    <Box
      key={item}
      sx={{
        borderRight:
          index !== 3 ? "1px solid rgba(255,255,255,0.25)" : "none",
      }}
    >
      <Button
        sx={{
          color: "#fff",
          px: 2.5,
          py: 1.2,
          minWidth: "70px",
          borderRadius: 0,
          textTransform: "none",
          "&:hover": {
            bgcolor: "#1a1a1a",
          },
        }}
      >
        {item}
      </Button>
    </Box>
  ))}
</Box>
          </Grid>
        </Grid>

        {/* Table */}
        <TableContainer>
          <Table>
            <TableHead sx={{ bgcolor: "#F8F9FC" }}>
              <TableRow>
                {["ID", "SERVICE IMAGE", "SERVICE TYPE", "CITY", "STATUS", "ACTIONS"].map(head => (
                  <TableCell key={head} sx={{ fontWeight: 600, textAlign: "center", textTransform: "uppercase",fontSize: 14, color: "#2f1515" }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0? paginatedData.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell sx={{ fontWeight: 500, fontSize:"14px", textAlign: "center" }}>{row.id}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Avatar
                      src={row.serviceImage}
                      variant="square"
                      sx={{ width: 50, fontSize:"14px", height: 50, mx: "auto", objectFit: "contain" }}
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize:"14px", fontFamily: "Poppins" }}>{row.serviceType}</TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize:"14px", fontFamily: "Poppins" }}>{row.city}</TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize:"14px", fontFamily: "Poppins" }}>
                    <Chip
                      label={row.status}
                      size="small"
                      icon={<Box sx={{ width: 6, height: 6,  borderRadius: "50%", bgcolor: row.status === "Active"? "#ffe600" : "#F44336" }} />}
                      sx={{
                        bgcolor: row.status === "Active"? "#E8F5E9" : "#FFEBEE",
                        color: row.status === "Active"? "#2E7D32" : "#C62828",
                        borderRadius: 5,
                        fontWeight: 600,
                        padding: "10px",
                        fontFamily: "Poppins",

                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize:"14px", fontFamily: "Poppins", color: "#888" }}>
                   
                    <IconButton size="small" sx={{ color: "#888" }}><EditOutlined fontSize="small" /></IconButton>Edit
                    <IconButton size="small" sx={{ color: "#888" }}><DeleteOutline fontSize="small" /></IconButton>Delete
                  </TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">No results found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Footer Pagination */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, flexWrap: "wrap", gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Showing {filteredData.length === 0? 0 : ((page - 1) * rowsPerPage) + 1} to {Math.min(page * rowsPerPage, filteredData.length)} of {totalResults} results
          </Typography>
          <Pagination
            count={Math.ceil(totalResults / rowsPerPage)}
            page={page}
            onChange={(e, val) => setPage(val)}
            shape="rounded"
            sx={{ "&.Mui-selected": { bgcolor: "#000!important", color: "#fff", borderRadius: 1 } }}
          />
        </Box>
      </Paper>
    </Box>
    <ServicetypeAddModal
            openDialog={addServicetypeModal}
            handleClose={handleCloseAddServiceModal}
          ></ServicetypeAddModal>
          <ServicetypeUpdateModal
            openDialog={updateServicetypeModal}
            // id={customerId}
            handleClose={handleCloseUpdateServiceModal}
          ></ServicetypeUpdateModal>
          <ServicetypeDeleteDialog
            openDialog={deleteServicetypeModal}
            // id={customerId}
            handleClose={handleCloseDeleteServiceModal}
          ></ServicetypeDeleteDialog>
          </>
  );
};

export default CityServicetypefare;